<template>
    <v-snackbar
        v-model="model"
        :color="getAlertColor"
        data-cy="alert"
        :timeout="4000"
        class="no-print"
    >
        <span v-if="internationalisedMessage" class="white-text sentry-unmask">
            <span
                v-if="
                    alertParameters && Object.keys(alertParameters).length > 0
                "
            >
                {{ t(alertMessage ?? "default.empty", alertParameters) }}
            </span>
            <span v-else> {{ t(alertMessage ?? "default.empty") }}</span>
        </span>
        <span v-else class="white-text">{{ alertMessage }}</span>
        <template #actions>
            <v-icon
                :icon="mdiClose"
                class="pointer-cursor mr-1"
                @click="closeAlert"
            />
        </template>
    </v-snackbar>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { mdiClose } from "@mdi/js";
import { ColourPalette } from "@esenda/core-ui/constants";
const { t } = useI18n();

const props = defineProps<{
    modelValue: boolean;
    alertMessage: string;
    alertColor?: string;
    internationalisedMessage?: boolean;
    alertParameters?: any;
}>();

const emit = defineEmits(["update:modelValue"]);

const model = computed({
    get: () => props.modelValue,
    set: (value) => {
        emit("update:modelValue", value);
    },
});

const closeAlert = () => {
    emit("update:modelValue", false);
};

const getAlertColor = computed(() => {
    let color;
    switch (props.alertColor) {
        case "error":
            color = ColourPalette.RED_100;
            break;
        case "success":
            color = ColourPalette.SUCCESS_700;
            break;
        case "warning":
            color = ColourPalette.WARNING_700;
            break;
    }
    return color;
});
</script>
